/** Layout für die BPMN-nahe Prozessansicht: reine Funktion, keine Abhängigkeiten.

    Jeder Schritt bekommt eine eigene Spalte (links nach rechts, in Reihenfolge),
    die Bahn bestimmt die y-Position (Auslöser oben, Agent mittig, Mensch unten).
    Start- und Endknoten werden als `__start` / `__ende` ergänzt. */

export interface ProzessSchritt {
  key: string;
  bahn: 'agent' | 'mensch';
  was: string;
  delegation: string;
  tools: string[];
  entscheidung: string;
  uebergabe: boolean;
}

export interface LaufSchritt {
  key: string;
  status: 'offen' | 'laeuft' | 'erledigt' | 'uebersprungen' | 'fehler' | 'wartet';
  zeit?: string;
  detail?: string;
}

export type Bahn = 'ausloeser' | 'agent' | 'mensch';
export type KnotenForm = 'start' | 'schritt' | 'gateway' | 'mensch' | 'ende';

export interface LayoutKnoten {
  key: string;
  bahn: Bahn;
  x: number;
  y: number;
  form: KnotenForm;
}

export interface LayoutKante {
  von: string;
  nach: string;
}

export interface ProzessLayout {
  knoten: LayoutKnoten[];
  kanten: LayoutKante[];
  breite: number;
}

export const BAHN_HOEHE = 110;
export const SPALTE_BREITE = 170;
export const BAHN_Y: Record<Bahn, number> = {
  ausloeser: 0,
  agent: BAHN_HOEHE,
  mensch: BAHN_HOEHE * 2,
};

export function prozessLayout(
  schritte: ProzessSchritt[],
  opts?: { spalte?: number },
): ProzessLayout {
  const spalte = opts?.spalte ?? SPALTE_BREITE;

  const knoten: LayoutKnoten[] = [
    { key: '__start', bahn: 'ausloeser', x: 0, y: BAHN_Y.ausloeser, form: 'start' },
  ];
  schritte.forEach((s, i) => {
    let form: KnotenForm = 'schritt';
    if (s.bahn === 'mensch') form = 'mensch';
    else if (s.entscheidung) form = 'gateway';
    knoten.push({ key: s.key, bahn: s.bahn, x: (i + 1) * spalte, y: BAHN_Y[s.bahn], form });
  });
  knoten.push({
    key: '__ende',
    bahn: 'ausloeser',
    x: (schritte.length + 1) * spalte,
    y: BAHN_Y.ausloeser,
    form: 'ende',
  });

  const kanten: LayoutKante[] = [];
  for (let i = 0; i < knoten.length - 1; i++) {
    kanten.push({ von: knoten[i].key, nach: knoten[i + 1].key });
  }

  return { knoten, kanten, breite: spalte * knoten.length };
}
